
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDePreguntas, Buscador } from './preguntas-controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        public get Controlador(): ControladorDePreguntas { return Model; }
        public get Buscador(): Buscador { return Model.Buscador; }

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {

            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Filtros[key] = Number( this.Buscador.Filtros.Valores[key] );
            }

            this.Abierto = false;
            this.$nextTick( () => { this.Abierto = true; } );
        }

        public Estado: 'cargando' | 'vacio' | 'ok' | 'error' = 'cargando';
        public Abierto: boolean = false;

        public Filtros: Record<string, number> = {
            Plataforma: 0,
            Cuenta: 0,
            Estado: 0,
            Tipo: 0,
            Limite: 0,
            Orden: 0,
            Indice: 0,
        };

        public Filtrar()
        {

            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Buscador.Filtros.Valores[key] = this.Filtros[key];
            }

            this.Buscador.Buscar(1);
            this.Abierto = false;
        }
    }
